import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.PMIS_SERVER_PREFIX}/duplicate-merging-pmis`;
const endpoints = {
    create: () => `${RESOURCE_ENDPOINT}`,
};

export default class DuplicateMergingPmisApi {
    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    };
}
